import { menuItemToLink } from '../const/menuItemToLink'

export const ACTIVE_ADMIN_MENU_STORAGE_KEY = 'activeAdminMenu'

const validAdminMenuLinks = new Set(
  Object.values(menuItemToLink).filter(Boolean)
)

export const isValidAdminMenuLink = link => validAdminMenuLinks.has(link)

const getSessionStorage = storage => {
  if (storage) return storage
  if (typeof window === 'undefined') return null
  return window.sessionStorage
}

export const rememberActiveAdminMenu = (link, storage) => {
  if (!isValidAdminMenuLink(link)) return

  try {
    getSessionStorage(storage)?.setItem(ACTIVE_ADMIN_MENU_STORAGE_KEY, link)
  } catch (error) {
    console.warn('Unable to remember the active admin menu', error)
  }
}

export const getRememberedActiveAdminMenu = storage => {
  try {
    const link = getSessionStorage(storage)?.getItem(
      ACTIVE_ADMIN_MENU_STORAGE_KEY
    )
    return isValidAdminMenuLink(link) ? link : null
  } catch (error) {
    console.warn('Unable to restore the active admin menu', error)
    return null
  }
}
